import { render, staticRenderFns } from "./CreateQuoteModalSecondStep.vue?vue&type=template&id=60205c5a&scoped=true&"
import script from "./CreateQuoteModalSecondStep.vue?vue&type=script&lang=js&"
export * from "./CreateQuoteModalSecondStep.vue?vue&type=script&lang=js&"
import style0 from "./CreateQuoteModalSecondStep.vue?vue&type=style&index=0&id=60205c5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60205c5a",
  null
  
)

export default component.exports